import { DatePivotParams } from "../../entities/date_pivot_params";

export const defaultChartViewerConfig = (viewParams: DatePivotParams) => {
  const dateHierarchy = viewParams?.dateHierarchy || "week";
  const selectedMeasure = viewParams?.measure || "Forecasted Sales";

  return {
    chartType: "bar" as const,
    xAxisField: dateHierarchy,
    yAxisFields: ["value"],
    datasetLabels: {
      value: selectedMeasure,
    },
    measureFilter: selectedMeasure,
  };
};


